import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'app-tertiary-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: '../base-button/base-button.component.html',
  styleUrls: ['../base-button/base-button.component.scss', './tertiary-button.component.scss']
})
export class TertiaryButtonComponent extends BaseButtonComponent {}
